// import React, { FC, useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   Input,
//   Button,
//   Modal,
//   Row,
//   Col,
//   Dropdown,
//   Menu,
//   Switch,
//   Radio,
// } from "antd";
// import { SearchOutlined, EllipsisOutlined } from "@ant-design/icons";
// import _ from "lodash";
// import { PAGE_TYPES } from "utils/PageTypes";
// import { GET_USERS_LIST } from "reducers/authReducer";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   getCreatePagePublishTopic,
//   getPagesRequestPublishTopic,
//   getMembersPageCreatedPublishTopic,
// } from "hooks/MQTTConstants";
// import moment from "moment";
// import { Formik } from "formik";
// import * as yup from "yup";
// import { RootState } from "reducers/rootReducer";
// import { SocketTopics } from "../../constants/enums";
// import useLocalStorageService from "../../services/localStorage";
// import { RID, CID } from "../../constants/localStoreKeys";
// import { getRequestHeader } from "../../helpers/request/RequestPayload";
// import { wrapRequestPayload } from "../../helpers/request/RequestPayload";

// function formatUserFilterText(text) {
//   var result = "";
//   let comp = text
//     .trim()
//     .split(" ")
//     .filter((word) => word.length > 2)
//     .map((x) => {
//       return formatForRedis(x) + "*";
//     });
//   if (comp.length == 0) {
//     return result;
//   }

//   comp.forEach((element) => {
//     result += `@firstName:(${element})|@lastName:(${element})|`;
//   });
//   console.log("comp here", comp);
//   result += `@beamIds:{${comp.join("|")}}`;

//   return `(${result})`;
// }

// function formatForRedis(text) {
//   return text.replace(/-|_|\./g, function (x) {
//     return `\\${x}`;
//   });
// }

// let timeout: NodeJS.Timeout;

// const CreateNewPageModal: FC<{
//   isModalVisible?: CreateNewPageModelObj;
//   setIsModalVisible?: (isModalVisible: CreateNewPageModelObj) => void;
//   onClose?: () => void;
//   socket?: ISocket;
//   currentLocation?: CurrentLocation;
//   page_group?: any;
// }> = ({
//   isModalVisible,
//   setIsModalVisible,
//   onClose,
//   socket,
//   currentLocation,
// }) => {
//   const dispatch = useDispatch();
//   const { users, allUsers, searchBds, findUsersToPage } = useSelector(
//     (state: RootState) => state.auth
//   );
//   const { userInfo } = useSelector((state: RootState) => state.auth);
//   const [searchText, setSearchText] = useState<string>("");
//   const [initialState, setInitialState] = useState<{ title: string }>({
//     title: "",
//   });

//   const { getLocalStorageItem } = useLocalStorageService();

//   const [text, setText] = useState<string>("");
//   const [groupTitleText, setGroupTitleText] = useState<string>("");
//   const [selectedUsers, setSelectedUsers] = useState<SelectedUser[]>([]);
//   const { adminRoles } = useSelector(
//     (state: RootState) => state.dashboard
//   );

//   const validationSchema = yup.object().shape({
//     title: yup
//       .string()
//       .min(2, `Title has to be at least 2 characters`)
//       .required("Title is required"),
//   });

//   useEffect(() => {
//     // dispatch(GET_USERS_LIST());
//   }, []);

//   // useEffect(() => {
//   //   // console.log(users);
//   // }, [users]);

//   const handleCancel = () => {
//     const prevObj: CreateNewPageModelObj = { ...isModalVisible };
//     setIsModalVisible({
//       ...prevObj,
//       visible: false,
//     });
//     onClose && onClose();
//   };

// const createPage = (
//   title: string,
//   members: any,
//   location?: CurrentLocation
// ) => {
//   const changes = [
//     {
//       op: "replace",
//       path: "/persistent/static/metadata/title",
//       value: title,
//     },
//     {
//       op: "replace",
//       path: "/persistent/static/metadata/type",
//       value: isModalVisible.type,
//     },
//     {
//       op: "replace",
//       path: "/persistent/static/metadata/createdAt",
//       value: new Date().getTime(),
//     },
//     {
//       op: "replace",
//       path: `/persistent/static/metadata/members/users`,
//       value: members,
//     },
//     {
//       op: "replace",
//       path: `/persistent/static/live/location`,
//       value: {
//         coordinates: {
//           lat: location.latitude,
//           long: location.longitude,
//         },
//       },
//     },
//   ];
//   socket.publishToEvent(
//     SocketTopics.PublishPageTopics,
//     getCreatePagePublishTopic(),
//     wrapRequestPayload({ changes }),
//     (data) => {
//       if (!data.status) {
//         console.log("Publish error: ", data.message);
//       }
//     }
//   );
// };

// const handleOk = (values: any) => {
//   let members: any = {
//     [localStorage.getItem("RID")]: {
//       role: "edit",
//       beamId: `${userInfo.firstName}.${userInfo.lastName}`,
//     },
//   };

//   let expiresAt = new Date();
//   expiresAt.setDate(expiresAt.getDate() + 1);

//   selectedUsers.map((x: any) => {
//     members[x.userId] = {
//       role: "write",
//       beamId: `${x.firstName}.${x.lastName}`,
//       pending: {
//         invited: true,
//         expiresAt: expiresAt.getTime(),
//       },
//     };
//   });

//   if (socket.client && values.title) {
//     if (currentLocation) {
//       createPage(values.title, members, currentLocation);
//     } else {
//       alert("Geolocation is not supported by this browser.");
//       createPage(values.title, members);
//     }
//     const prevObj: CreateNewPageModelObj = { ...isModalVisible };
//     setIsModalVisible({
//       ...prevObj,
//       visible: false,
//     });
//     onClose && onClose();
//   }
// };

//   const getRole = (userObj) => {
//     const role = adminRoles?.find((x)=>{
//       return x._id === userObj?.roleId
//     });
//     return role?.name;
//   }

//   const addUser = (user) => {
//     setSelectedUsers([
//       ...selectedUsers,
//       {
//         userId: user.id,
//         chat_name: user.beamId,
//         email: user.email,
//         phone: user.phone,
//         firstName: user.firstName,
//         lastName: user.lastName,
//         roleId: user.roleId,
//         department: user.department
//       },
//     ]);
//   };

//   const removeUser = (user) => {
//     selectedUsers.splice(
//       selectedUsers.findIndex(
//         (item) => item.userId === (user.id || user.userId)
//       ),
//       1
//     );
//     setSelectedUsers([...selectedUsers]);
//   };

//   useEffect(() => {
//     if (findUsersToPage) {
//       aggregateUser(findUsersToPage?.queryId);
//     }
//   }, [findUsersToPage]);

//   const aggregateUser = (inputQueryId: string, filterText?: string) => {
//     console.log("aggregate user");
//     var searchQuery = `@userType:{user}`;
//     if (filterText && filterText.length > 2) {
//       searchQuery += formatUserFilterText(filterText);
//     }
//     socket.publishToEvent(
//       SocketTopics.PublishPageTopics,
//       `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
//         "CID"
//       )}/service/bds/aggregateBds`,
//       wrapRequestPayload({
//         select: {
//           index: {
//             searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
//             searchQuery: searchQuery,
//             searchOptions: "TIMEOUT 10000",
//           },
//           list: {
//             inputQueryId: inputQueryId,
//           },
//           load: {
//             objectId: "$.objectId",
//             liveObject: "$.persistent.static",
//           },
//         },
//         groupBy: {
//           properties: ["@objectId"],
//           reducers: [
//             {
//               func: "TOLIST",
//               arguments: ["@liveObject"],
//               name: "profile",
//             },
//           ],
//         },
//         apply: {
//           expression: "",
//           name: "",
//         },
//         filter: {
//           expression: "",
//         },
//         result: {
//           pagination: {
//             offset: 0,
//             limit: 10000,
//           },
//         },
//         anyStatus: false,
//       })
//     );
//   };

//   const editMenu = (
//     <div className="menu-container edit-menu ml-auto people-dropdown">
//       <div className="menu-item">
//         <Radio.Group defaultValue="Edit">
//           {["Edit", "Read", "Write"].map((item) => (
//             <Radio.Button value={item} key={item}>
//               {item}
//             </Radio.Button>
//           ))}
//         </Radio.Group>
//       </div>
//       <div className="menu-item">
//         <p className="mr-3">Classify</p> <Switch defaultChecked />
//       </div>
//     </div>
//   );

//   return (
//     <Modal
//       title={`Create ${isModalVisible.type} page`}
//       visible={isModalVisible.visible}
//       onOk={handleOk}
//       onCancel={handleCancel}
//       width="480px"
//       className="beam-modal scrollable"
//       footer={[]}
//       destroyOnClose={true}
//     >
//       <Formik
//         initialValues={initialState}
//         validationSchema={validationSchema}
//         onSubmit={handleOk}
//       >
//         {({
//           values,
//           errors,
//           touched,
//           handleChange,
//           handleBlur,
//           handleSubmit,
//         }) => (
//           <>
//             <Row>
//               <Col span={24}>
//                 <Input
//                   onBlur={handleBlur}
//                   name="title"
//                   onChange={handleChange}
//                   placeholder="Page Title"
//                 />
//                 <span className="error text-danger">
//                   <small>
//                     {errors && touched && touched["title"] && errors["title"]}
//                   </small>
//                 </span>
//               </Col>
//             </Row>
//             <Row className="scrollable-body mt-4">
//               <Col span={24}>
//                 <Row className="d-flex mb-4">
//                   <Col>
//                     <h5>Add people to page</h5>
//                   </Col>
//                   <Col>
//                     <p>{selectedUsers.length} people</p>
//                   </Col>
//                 </Row>
//                 {selectedUsers &&
//                   selectedUsers.map((user, index) => (
//                     <Row className="person-item" key={index}>
//                       <Col span={4}>
//                         <img
//                           src={
//                             user?.profileImage?.urls?.original?.url ??
//                             "/images/users/user.png"
//                           }
//                           width="45"
//                           height="45"
//                         />
//                       </Col>
//                       <Col span={13}>
//                         <h5>
//                           {user.chat_name &&
//                           !user.chat_name.includes("undefined")
//                             ? user.chat_name
//                             : "User " + index}
//                         </h5>
//                         <p>{getRole(user) || "-"}</p>
//                         <p>{user.department || "-"}</p>
//                       </Col>
//                       <Col span={7} className="d-block t-right">
//                         <Button
//                           className="beam-btn orange-btn"
//                           onClick={() => removeUser(user)}
//                         >
//                           Remove
//                         </Button>
//                         <Dropdown
//                           overlay={editMenu}
//                           className="message-dropdown"
//                           placement="bottomRight"
//                         >
//                           <a
//                             className="ant-dropdown-link"
//                             onClick={(e) => e.preventDefault()}
//                           >
//                             <EllipsisOutlined />
//                           </a>
//                         </Dropdown>
//                       </Col>
//                     </Row>
//                   ))}
//                 <Row className="mb-4">
//                   <Col span={24}>
//                     <Input
//                       onChange={(e) => {
//                         const value: string = e.target.value;
//                         if (timeout) clearTimeout(timeout);
//                         timeout = setTimeout(() => {
//                           // dispatch(GET_USERS_LIST(value));
//                           if (findUsersToPage) {
//                             aggregateUser(findUsersToPage?.queryId, value);
//                           }
//                         }, 500);
//                       }}
//                       placeholder="Search"
//                       suffix={<SearchOutlined />}
//                     />
//                   </Col>
//                 </Row>
//                 {searchBds &&
//                   searchBds
//                     .filter(
//                       (search) =>
//                         search.name &&
//                         search.name
//                           .toLowerCase()
//                           .includes(searchText.toLowerCase())
//                     )
//                     .map(
//                       (user, index) =>
//                         !selectedUsers.find(
//                           (item) => item.userId === user.id
//                         ) && (
//                           <Row className="person-item" key={index}>
//                             <Col span={4}>
//                               <img
//                                 src={
//                                   user?.profileImage?.urls?.original?.url ??
//                                   "/images/users/user.png"
//                                 }
//                                 width="45"
//                                 height="45"
//                               />
//                             </Col>
//                             <Col span={13}>
//                               <h5>
//                                 {user.beamId && !user.beamId.includes("undefined")
//                                   ? user.beamId
//                                   : "User " + index}
//                               </h5>
//                               {/* <p>{user.email || "N/A"}</p>
//                               <p>{user.phone || "N/A"}</p> */}
//                               <p>{getRole(user) || "-"}</p>
//                         <p>{user.department || "-"}</p>
//                             </Col>
//                             <Col span={7} className="d-block t-right">
//                               {selectedUsers.find(
//                                 (item) => item.userId === user.id
//                               ) ? (
//                                 <Button
//                                   className="beam-btn orange-btn"
//                                   onClick={() => removeUser(user)}
//                                 >
//                                   Remove
//                                 </Button>
//                               ) : (
//                                 <Button
//                                   className="beam-btn green-btn"
//                                   onClick={() => addUser(user)}
//                                 >
//                                   Add
//                                 </Button>
//                               )}
//                               <Dropdown
//                                 overlay={editMenu}
//                                 className="message-dropdown"
//                                 placement="bottomRight"
//                               >
//                                 <a
//                                   className="ant-dropdown-link"
//                                   onClick={(e) => e.preventDefault()}
//                                 >
//                                   <EllipsisOutlined />
//                                 </a>
//                               </Dropdown>
//                             </Col>
//                           </Row>
//                         )
//                     )}
//                 {/* {_.times(3, (idx) => (
// 							<Row className="person-item" key={idx}>
// 								<Col span={4}><img src={`/images/users/user-${idx}.png`} width="45" height="45" /></Col>
// 								<Col span={15}>
// 									<h5>Carla Vaccaro {idx}</h5>
// 									<p>support@beam.live</p>
// 									<p>+36 1 568-9874</p>
// 								</Col>
// 								<Col span={5} className="t-right">
// 									<Button className="beam-btn green-btn">Add</Button>
// 								</Col>
// 							</Row>
// 						))} */}
//               </Col>
//             </Row>
// <Row className="action-grp mt-4 sticky-footer">
//   <Col span={14} className="pr-2">
//     <Button
//       className="beam-btn green-btn cover w-full"
//       onClick={() => handleSubmit()}
//     >
//       Save
//     </Button>
//   </Col>
//   <Col span={10} className="pl-2">
//     <Button
//       className="beam-btn orange-btn bordered w-full"
//       onClick={handleCancel}
//     >
//       Cancel
//     </Button>
//   </Col>
// </Row>
//           </>
//         )}
//       </Formik>
//     </Modal>
//   );
// };

// export default CreateNewPageModal;

import React, { FC, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  Dropdown,
  Menu,
  Switch,
  Radio,
  Form,
} from "antd";
import {
  SearchOutlined,
  EllipsisOutlined,
  ConsoleSqlOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";

import {
  GET_PAGE,
  GET_USERS_LIST,
  GET_ALL_FRIEND_PAGE,
  GET_ADMIN_GROUPS,
  GET_ADMIN_GROUP_MEMBERS,
} from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import {
  wrapRequestPayload,
  getMessageRequestPayload,
} from "../../helpers/request/RequestPayload";
import AddGroupModal from "components/Modals/AddGroupModal";
import InvitePeopleModal from "components/Modals/InvitePeopleModal";

import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, UUID, RID } from "../../constants/localStoreKeys";
import { ReactSVG } from "react-svg";

import {
  getModifyPageSubscriptionTopic,
  getMembersRemoveFromPagePublishTopic,
} from "hooks/MQTTConstants";

import {
  getCreatePagePublishTopic,
  getPagesRequestPublishTopic,
  getMembersPageCreatedPublishTopic,
} from "hooks/MQTTConstants";

import { generateUUID } from "utils/appUtil";

let timeout: NodeJS.Timeout;

function formatUserFilterText(text) {
  var result = "";
  let comp = text
    .trim()
    .split(" ")
    .filter((word) => word.length > 2)
    .map((x) => {
      return formatForRedis(x) + "*";
    });
  if (comp.length == 0) {
    return result;
  }

  comp.forEach((element) => {
    result += `@firstName:(${element})|@lastName:(${element})|`;
  });
  console.log("comp here", comp);
  result += `@beamIds:{${comp.join("|")}}`;

  return `(${result})`;
}

function formatForRedis(text) {
  return text.replace(/-|_|\./g, function (x) {
    return `\\${x}`;
  });
}

const CreateNewPageModal: FC<{
  isModalVisible?: CreateNewPageModelObj;
  setIsModalVisible?: (isModalVisible: CreateNewPageModelObj) => void;
  onClose?: () => void;
  socket?: ISocket;
  currentLocation?: CurrentLocation;
  page_group?: any;
}> = ({
  onClose,
  socket,
  currentLocation,
  page_group,
  isModalVisible,
  setIsModalVisible,
}) => {
  const { selectedItem, userSearchPage, friendPages, adminSearchGroup } =
    useSelector((state: RootState) => state.search);
  const { users, findUsersToPage, searchBds, allUsers } = useSelector(
    (state: RootState) => state.auth
  );
  const [createPageForm] = Form.useForm();
  const scrollRef = useRef(null);
  // const [isModalVisible, setIsModalVisible] = useState(true);
  const [groupModalOpen, setgroupModalOpen] = useState(false);
  const [inviteModalOpen, setinviteModalOpen] = useState(false);
  // const [allUsers, setAllUsers] = useState([]);
  // const [selectedUsers, setSelectedUsers] = useState<UserInfo[]>(
  const [selectedUsers, setSelectedUsers] = useState<any>({});
  const [selectedGroups, setSelectedGroups] = useState<any>({});

  const { projects } = useSelector((state: RootState) => state.dashboard);
  const [searchInput, setSearchInput] = useState("");
  const [groupSaving, setGroupSaving] = useState();
  const [selectedFilter, setSelectedFilter] = useState("people");
  const [groupMembersList, setGroupMembersList] = useState({});
  const { adminRoles } = useSelector((state: RootState) => state.dashboard);
  const { requestIds } = useSelector((state: RootState) => state.dashboard);


  const handleCancel = () => {
    const prevObj: CreateNewPageModelObj = { ...isModalVisible };
    setIsModalVisible({
      ...prevObj,
      visible: false,
    });
    onClose && onClose();
  };

  const dispatch = useDispatch();

  const { getLocalStorageItem } = useLocalStorageService();

  // const searchUser = (inputQueryId: string, filterText?: string) => {
  //   let serviceId = "cudb-live";
  //   var searchQuery = `@userType:{user}@serviceId:{${formatForRedis(
  //     serviceId
  //   )}}`;
  //   if (filterText && filterText.length > 2) {
  //     searchQuery += formatUserFilterText(filterText);
  //   }
  //   socket.publishToEvent(
  //     SocketTopics.PublishPageTopics,
  //     `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
  //       "CID"
  //     )}/service/bds/searchBds`,
  //     wrapRequestPayload({
  //       pagination: { offset: 0, limit: 100 },
  //       searchIndex: "beamdev:userNameIndex",
  //       searchQuery: searchQuery,
  //       searchOptions: "SORTBY beamIds ASC",
  //       inputQueryId,
  //     })
  //   );
  // };

  const aggregateUser = (inputQueryId: string, filterText?: string) => {
    var searchQuery = `@userType:{user}`;
    if (filterText && filterText.length > 2) {
      searchQuery += formatUserFilterText(filterText);
    }
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/bds/aggregateBds`,
      wrapRequestPayload({
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: searchQuery,
            searchOptions: "TIMEOUT 10000",
          },
          list: {
            inputQueryId: inputQueryId,
          },
          load: {
            objectId: "$.objectId",
            liveObject: "$.persistent.static",
            status: "$.nonpersistent.static.live.status"
          },
        },
        groupBy: {
          properties: ["@objectId"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@liveObject"],
              name: "profile",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 10000,
          },
        },
        anyStatus: false,
      }, requestIds.user)
    );
  };

  // useEffect(() => {
  //   if (selectedItem) {
  //     const orgGroups =
  //       selectedItem?.persistent?.static?.metadata?.members?.orgGroups || {};
  //     const users =
  //       selectedItem?.persistent?.static?.metadata?.members?.users || {};
  //     const orgUsersSet = new Set([]);
  //     Object.keys(orgGroups)?.map((group) => {
  //       orgGroups[group].userIds.map((user) => {
  //         orgUsersSet.add(user);
  //       });
  //     });
  //     const orgUsersArray = Array.from(orgUsersSet);
  //     console.log("users here", users);
  //     console.log("org users here", orgUsersArray);

  //     orgUsersArray.map((user) => {
  //       if (users?.[user]?.role === "write") {
  //         delete users?.[user];
  //       }
  //     });

  //     setSelectedUsers(users);

  //     setSelectedGroups(orgGroups);

  //     setGroupSaving(undefined);

  //     dispatch(GET_PAGE({ payload: {} }));
  //     dispatch(GET_ALL_FRIEND_PAGE({ payload: {} }));
  //   }
  // }, [selectedItem]);

  const createPage = (
    title: string,
    members: any,
    groups: any,
    location?: CurrentLocation
  ) => {
    const changes = [
      {
        op: "replace",
        path: "/persistent/static/metadata/title",
        value: title,
      },
      {
        op: "replace",
        path: "/persistent/static/metadata/type",
        value: isModalVisible.type,
      },
      {
        op: "replace",
        path: "/persistent/static/metadata/createdAt",
        value: new Date().getTime(),
      },
      {
        op: "add",
        path: "/nonpersistent/dynamic/metadata/lastSent/members/updatedAt",
        value: new Date().getTime()
      },
      {
        op: "replace",
        path: `/persistent/static/metadata/members/users`,
        value: members,
      },
      {
        op: "replace",
        path: `/persistent/static/metadata/members/orgGroups`,
        value: groups,
      }
    ];
    if(location){
      changes.push({
        op: "replace",
        path: `/persistent/static/live/location`,
        value: {
          coordinates: {
            lat: location.latitude,
            long: location.longitude,
          },
        },
      },)
    }
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getCreatePagePublishTopic(),
      wrapRequestPayload({ changes }),
      (data) => {
        if (!data.status) {
          console.log("Publish error: ", data.message);
        }
      }
    );
  };

  const handleOk = (values: any) => {
    let members: any = {};
    let groups = {};
    let expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + 1);
    Object.keys(selectedUsers).map((x: any) => {
      members[x] = {
        role: "write",
        pending: {
          invited: true,
          expiresAt: expiresAt.getTime(),
        },
      };
    });

    Object.keys(selectedGroups).map((x: any) => {
      groups[selectedGroups[x]?.organization?.queryId] = {
        queryId: selectedGroups[x]?.organization?.queryId,
        defaultRole: "write",
        name: selectedGroups[x]?.title,
        userIds: Object.keys(selectedGroups[x]?.members),
      };
      members = {
        ...members,
        ...selectedGroups[x]?.members,
      };
    });

    members[localStorage.getItem("RID")] = {
      role: "edit",
    };

    if (socket.client && values.title) {
      if (currentLocation) {
        createPage(values.title, members, groups, currentLocation);
      } else {
        // alert("Geolocation is not supported by this browser.");
        createPage(values.title, members, groups);
      }
      const prevObj: CreateNewPageModelObj = { ...isModalVisible };
      setIsModalVisible({
        ...prevObj,
        visible: false,
      });
      onClose && onClose();
    }
  };

  useEffect(() => {
    if (findUsersToPage) {
      aggregateUser(findUsersToPage.queryId);
    }
  }, [findUsersToPage]);

  useEffect(() => {
    if (userSearchPage) {
      console.log("user search page", userSearchPage);
    }
  }, [userSearchPage]);

  const addUser = (user) => {
    let expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + 1);
    const users = {
      ...selectedUsers,
      [user.id]: {
        role: "write",
        pending: {
          invited: true,
          expiresAt: expiresAt.getTime(),
        },
      },
    };
    setSelectedUsers(users);
    if (scrollRef) {
      scrollRef.current.scrollTop = 0;
    }
  };

  const addGroup = (page) => {
    const groups = {
      ...selectedGroups,
      [page.organization.queryId]: {
        ...page,
      },
    };
    setSelectedGroups(groups);
  };

  const addPage = (page) => {
    console.log("add group here", page);
    console.log("selected users here", selectedUsers);

    if (page?.organization?.queryId) {
      addGroup(page);
    } else {
      Object.keys(page.members).map((member) => {
        if (!Object.keys(selectedUsers).find((item) => item === member)) {
          addUser({
            id: member,
            beamId: page.members[member].beamId,
          });
          console.log("add user", {
            id: member,
            beamId: page.members[member].beamId,
          });
        }
      });
    }
  };

  const addAdminGroup = (page) => {
    console.log("get page members here", page);
    // setGroupSaving(page.objectId.toString());
    dispatch(
      GET_ADMIN_GROUP_MEMBERS({
        queryId: page.objectId.toString(),
        callback: (response) => {
          console.log("callback response here", response);
          const members = {};
          response?.data?.list.map((user) => {
            if(user.split(":")?.[1] === 'user'){
              members[user.split(":")?.[2]] = {};
            }
            return user;
          });
          addGroup({
            organization: {
              queryId: page.objectId.toString(),
            },
            members,
            title: page.info.name,
          });
        },
      })
    );
  };

  const removeGroup = (page) => {
    delete selectedGroups[page.organization.queryId];
    const groups = { ...selectedGroups };
    setSelectedGroups(groups);
  };

  const getUser = (userObj) => {
    const user = allUsers?.find((obj) => obj.id === userObj.id);
    const role = adminRoles?.find((x) => {
      return x._id === user?.roleId;
    });
    return (
      <React.Fragment>
        <Col span={4}>
          <img
            src={
              user?.profileImage?.urls?.original?.url ??
              "/images/users/user.png"
            }
            width="45"
            height="45"
          />
        </Col>

        <Col span={13}>
          <h5>
            {user && user.beamId
              ? user.beamId
              : userObj?.beamId && userObj?.beamId !== ""
              ? userObj?.beamId
              : `user #${userObj.id}`}
          </h5>
          {/* <p>{user?.email ?? "-"}</p> */}
          <p>{role?.name ?? "-"}</p>
          <p>{user?.department ?? "-"}</p>
        </Col>
      </React.Fragment>
    );
  };

  const getRole = (userObj) => {
    const role = adminRoles?.find((x) => {
      return x._id === userObj?.roleId;
    });
    return role?.name;
  };

  const removeUser = (user) => {
    delete selectedUsers[user];
    const users = { ...selectedUsers };
    setSelectedUsers(users);
    if (scrollRef) {
      scrollRef.current.scrollTop = 0;
    }
  };

  const getFriendUser = (members) => {
    const user = Object.keys(members).find((x) => {
      return x !== localStorage.getItem("RID");
    });
    const userObj = allUsers?.find((obj) => obj.id === user);
    return {
      id: user,
      beamId: userObj,
    };
  };

  // const menu = (
  //   <Menu>
  //     <Menu.Item key={1}>item 1</Menu.Item>
  //   </Menu>
  // );

  const editMenu = (id, user) => {
    // console.log("edit menu");
    // const groups =
    //   selectedItem?.persistent?.static?.metadata?.members?.groups ?? {};
    // const userGroups = [];
    // Object.keys(groups).map((groupName) => {
    //   if ((groups[groupName]?.userIds ?? []).indexOf(id) !== -1)
    //     userGroups.push(groupName);
    // });
    return (
      <div className="menu-container edit-menu ml-auto people-dropdown">
        <div className="menu-item">
          <Radio.Group defaultValue={user.role} onChange={(event) => {}}>
            {["edit", "read", "write"].map((item) => (
              <Radio.Button value={item} key={item}>
                {item}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
        {/* <div
          className="menu-item"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
          }}
        >
          {Object.keys(groups).map((groupName, idx) => (
            <React.Fragment>
              <p style={{ color: "#fff" }}>{groupName}</p>{" "}
              <Switch
                defaultChecked={
                  userGroups.indexOf(groupName) !== -1 ? true : false
                }
                onChange={(checked) => {
                  sendPageUpdateEvent(
                    checked ? "addGroupMember" : "removeGroupMember",
                    {
                      userId: id,
                      group: groupName,
                    }
                  );
                }}
              />
            </React.Fragment>
          ))}
        </div> */}
      </div>
    );
  };

  const groupMembers = (users = {}) => {
    return (
      <div className="group-menu-container edit-menu ml-auto people-dropdown">
        <div className="menu-item">
          <Row className="beam-modal">
            <Col span={24}>
              {Object.keys(users).map((member) => (
                <Row key={member} className="person-item">
                  {getUser({ id: member })}
                </Row>
              ))}
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  useEffect(() => {
    dispatch(GET_PAGE({ payload: {} }));
    dispatch(GET_ALL_FRIEND_PAGE({ payload: {} }));
  }, []);

  return (
    <React.Fragment>
      <Modal
        title=""
        visible={isModalVisible.visible}
        onOk={() => {}}
        onCancel={handleCancel}
        width="520px"
        className="beam-modal scrollable max-height-fix"
        footer={[]}
        closable={false}
        destroyOnClose={true}
      >
        <Row className="d-flex mt-1 mb-4">
          <Col>
            <h3>Create regular page</h3>
          </Col>

          {/* {selectedItem && selectedItem.currentUserRole === "edit" && (
            <Col>
              <Button
                className="beam-btn blue-btn cover"
                onClick={() => {
                  setinviteModalOpen(true);
                }}
              >
                Invite external users
              </Button>
            </Col>
          )} */}
        </Row>

        <Form
          className="auth-form"
          name="login-form"
          id="login-form"
          layout="vertical"
          form={createPageForm}
          onFinish={(values) => {
            console.log("values here", values);
            handleOk(values);
          }}
          requiredMark={false}
        >
          <Row className="">
            <Col span={24}>
              <Form.Item
                name="title"
                rules={[{ required: true, message: "**Required Field" }]}
              >
                <Input type="text" placeholder="Page title" />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Input
                onChange={(e) => {
                  const value: string = e.target.value;
                  if(value === undefined || value === '')return;
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout(() => {
                    // dispatch(GET_USERS_LIST(value));
                    if (findUsersToPage) {
                      aggregateUser(findUsersToPage?.queryId, value);
                    }
                    dispatch(GET_PAGE({ search: value }));
                    dispatch(
                      GET_ADMIN_GROUPS({
                        search: value,
                        serviceId: projects?.userServiceId,
                      })
                    );
                  }, 500);
                  setSearchInput(value);
                }}
                placeholder="Search for users or groups or pages"
                suffix={<SearchOutlined />}
              />
            </Col>

            <Col span={24} className="mt-4">
              <InvitePeopleModal socket={socket} onClose={() => {handleCancel()}} page={false} />
            </Col>
          </Row>
          <Row className="scrollable-body mt-4" ref={scrollRef}>
            <Col span={24}>
              <Row className="d-flex mb-4">
                <Col>
                  <h5>On page</h5>
                </Col>
                <Col>
                  <p>{selectedUsers.length || 0} person</p>
                </Col>
              </Row>
              {selectedUsers &&
                Object.keys(selectedUsers).map((member) => (
                  <Row key={member} className="person-item">
                    {/* <Col span={4}>
                    <img src="/images/users/user.png" width="45" height="45" />
                  </Col> */}
                    {/* <Col span={13}> */}
                    {/* <h5>{`user# ${member}`}</h5> */}
                    {/* <p>{member.email || "-"}</p> */}
                    {/* <p>{member.phone || "-"}</p> */}
                    {/* </Col> */}

                    {getUser({ id: member, ...selectedUsers[member] })}
                    <Col span={7} className="t-right">
                      <Button
                        className="beam-btn orange-btn"
                        onClick={() => removeUser(member)}
                      >
                        Remove
                      </Button>
                      <Dropdown
                        trigger={["click"]}
                        overlay={editMenu(member, selectedUsers[member])}
                        // overlay={menu}
                        className="message-dropdown"
                        placement="bottomRight"
                      >
                        <a
                          className="ant-dropdown-link"
                          onClick={(e) => e.preventDefault()}
                        >
                          <EllipsisOutlined />
                        </a>
                      </Dropdown>
                    </Col>
                  </Row>
                ))}

              {selectedGroups &&
                Object.keys(selectedGroups).map((group) => (
                  <Row
                    className="person-item"
                    key={selectedGroups[group].queryId}
                  >
                    <Col span={4}>
                      <ReactSVG
                        src={`/images/community-blue-icon.svg`}
                        className="colorable mark-icon"
                      />
                    </Col>
                    <Col span={13}>
                      <h5>{selectedGroups[group].title}</h5>
                    </Col>
                    <Col span={7} className="t-right">
                      <React.Fragment>
                        <Button
                          className="beam-btn orange-btn"
                          onClick={() => {
                            removeGroup(selectedGroups[group]);
                          }}
                        >
                          Remove
                        </Button>
                        <Dropdown
                          trigger={["click"]}
                          onVisibleChange={(visible) => {
                            if (visible) {
                              const queryId = selectedGroups[group].queryId;
                              if (queryId) {
                                dispatch(
                                  GET_ADMIN_GROUP_MEMBERS({
                                    queryId,
                                    callback: (response) => {
                                      console.log(
                                        "callback response here",
                                        response
                                      );
                                      const members = {};
                                      response?.data?.list.map((user) => {
                                        if(user.split(":")?.[1] === 'user'){
                                          members[user.split(":")?.[2]] = {};
                                        }
                                        return user;
                                      });
                                      console.log("get page members", members);
                                      setGroupMembersList({
                                        ...groupMembersList,
                                        [selectedGroups[group].queryId]:
                                          members,
                                      });
                                    },
                                  })
                                );
                              }
                            }
                          }}
                          overlay={groupMembers(
                            groupMembersList?.[selectedGroups[group].queryId]
                          )}
                          // overlay={menu}
                          className="message-dropdown"
                          placement="bottomRight"
                        >
                          <a
                            className="ant-dropdown-link"
                            onClick={(e) => e.preventDefault()}
                          >
                            <EllipsisOutlined />
                          </a>
                        </Dropdown>
                      </React.Fragment>
                    </Col>
                  </Row>
                ))}

              <React.Fragment>
                <Row className="d-flex mt-4 mb-4">
                  <Col>
                    <h5>Add to page</h5>
                  </Col>
                </Row>

                {/* {searchInput !== "" && ( */}
                  <React.Fragment>
                    <Row className="d-flex mb-4">
                      <Col span={4}>
                        <Button
                          onClick={() => {
                            setSelectedFilter("people");
                          }}
                          className={`beam-btn ${
                            selectedFilter === "people" ? "green-btn cover" : ""
                          }`}
                        >
                          People
                        </Button>
                      </Col>
                      <Col span={7}>
                        <Button
                          onClick={() => {
                            setSelectedFilter("admin");
                          }}
                          className={`beam-btn ${
                            selectedFilter === "admin" ? "green-btn cover" : ""
                          }`}
                        >
                          Groups
                        </Button>
                      </Col>
                      <Col span={7}>
                        <Button
                          onClick={() => {
                            setSelectedFilter("user");
                          }}
                          className={`beam-btn ${
                            selectedFilter === "user" ? "green-btn cover" : ""
                          }`}
                        >
                          Pages
                        </Button>
                      </Col>
                    </Row>
                  </React.Fragment>
                {/* )} */}

                {searchBds &&
                  searchInput !== "" &&
                  selectedFilter === "people" &&
                  searchBds.map(
                    (user, index) =>
                      !Object.keys(selectedUsers).find(
                        (item) => item === user.id
                      ) && (
                        <Row className="person-item" key={index}>
                          <Col span={5}>
                            <img
                              src={
                                user?.profileImage?.urls?.original?.url ??
                                `/images/users/user-1.png`
                              }
                              width="45"
                              height="45"
                            />
                          </Col>
                          <Col span={12}>
                            <h5>{user.beamId}</h5>
                            {/* <p>{user.email || "-"}</p> */}
                            <p>{getRole(user) || "-"}</p>
                            <p>{user.department || "-"}</p>
                          </Col>
                          <Col span={7} className="t-right">
                            <React.Fragment>
                              {Object.keys(selectedUsers).find(
                                (item) => item === user.id
                              ) ? (
                                <Button
                                  className="beam-btn orange-btn mr-2"
                                  onClick={() => removeUser(user)}
                                >
                                  Remove
                                </Button>
                              ) : (
                                <Button
                                  className="beam-btn green-btn"
                                  onClick={() => addUser(user)}
                                >
                                  Add
                                </Button>
                              )}
                            </React.Fragment>
                            {/* <Dropdown overlay={editMenu} className="message-dropdown" placement="bottomRight">
                                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}><EllipsisOutlined /></a>
                                </Dropdown> */}
                          </Col>
                        </Row>
                      )
                  )}

                {friendPages &&
                selectedFilter === "people" &&
                  searchInput === "" &&
                  friendPages.map(
                    (page, index) =>
                      !Object.keys(selectedUsers).find(
                        (item) =>
                          item === getFriendUser(page.members).id ||
                          getFriendUser(page.members).id == undefined
                      ) && (
                        <Row className="person-item" key={page.pageId}>
                          {getUser(getFriendUser(page.members))}
                          <Col span={7} className="t-right">
                            <React.Fragment>
                              <Button
                                className="beam-btn green-btn"
                                onClick={() => {
                                  addPage(page);
                                }}
                              >
                                Add
                              </Button>
                            </React.Fragment>
                          </Col>
                        </Row>
                      )
                  )}

                {searchInput === "" && selectedFilter === "admin" && (
                  <React.Fragment>
                    {/* {userSearchPage &&
                      userSearchPage.filter((page) => {
                        return page.organization !== undefined;
                      }).length > 0 && <h6>Groups</h6>} */}

                    {userSearchPage &&
                      userSearchPage
                        .filter((page) => {
                          return page.organization !== undefined;
                        })
                        .map(
                          (page) =>
                            !Object.keys(selectedGroups).find(
                              (item) =>
                                selectedGroups[item]?.organization?.queryId ===
                                page.organization.queryId
                            ) && (
                              <Row className="person-item" key={page.pageId}>
                                <Col span={5}>
                                  <ReactSVG
                                    src={`/images/community-blue-icon.svg`}
                                    className="colorable mark-icon"
                                  />
                                </Col>
                                <Col span={12}>
                                  <h5>{page.title}</h5>
                                </Col>
                                <Col span={7} className="t-right">
                                  <React.Fragment>
                                    <Button
                                      className="beam-btn green-btn"
                                      onClick={() => {
                                        addPage(page);
                                      }}
                                    >
                                      Add group
                                    </Button>

                                    <Dropdown
                                      trigger={["click"]}
                                      onVisibleChange={(visible) => {
                                        if (visible) {
                                          const queryId =
                                            page?.organization?.queryId;
                                          if (queryId) {
                                            dispatch(
                                              GET_ADMIN_GROUP_MEMBERS({
                                                queryId,
                                                callback: (response) => {
                                                  console.log(
                                                    "callback response here",
                                                    response
                                                  );
                                                  const members = {};
                                                  response?.data?.list.map(
                                                    (user) => {
                                                      if(user.split(":")?.[1] === 'user'){
                                                        members[user.split(":")?.[2]] = {};
                                                      }
                                                      return user;
                                                    }
                                                  );
                                                  console.log(
                                                    "get page members",
                                                    members
                                                  );
                                                  setGroupMembersList({
                                                    ...groupMembersList,
                                                    [page?.organization
                                                      ?.queryId]: members,
                                                  });
                                                },
                                              })
                                            );
                                          }
                                        }
                                      }}
                                      overlay={groupMembers(
                                        groupMembersList?.[
                                          page?.organization?.queryId
                                        ]
                                      )}
                                      // overlay={menu}
                                      className="message-dropdown"
                                      placement="bottomRight"
                                    >
                                      <a
                                        className="ant-dropdown-link"
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        <EllipsisOutlined />
                                      </a>
                                    </Dropdown>
                                  </React.Fragment>
                                </Col>
                              </Row>
                            )
                        )}

                    {/* {userSearchPage &&
                      userSearchPage.filter((page) => {
                        return page.organization === undefined;
                      }).length > 0 && <h6>Pages</h6>} */}
                  </React.Fragment>
                )}

                {userSearchPage &&
                  (selectedFilter === "user") &&
                  userSearchPage
                    .filter((page) => {
                      return page.organization === undefined;
                    })
                    .map((page) => (
                      <Row className="person-item" key={page.pageId}>
                        <Col span={5}>
                          <ReactSVG
                            src={`/images/community-blue-icon.svg`}
                            className="colorable mark-icon"
                          />
                        </Col>
                        <Col span={12}>
                          <h5>{page.title}</h5>
                        </Col>
                        <Col span={7} className="t-right">
                          <React.Fragment>
                            <Button
                              className="beam-btn green-btn"
                              onClick={() => {
                                addPage(page);
                              }}
                            >
                              Add group
                            </Button>
                          </React.Fragment>
                        </Col>
                      </Row>
                    ))}

                {adminSearchGroup &&
                  searchInput !== "" &&
                  selectedFilter === "admin" &&
                  adminSearchGroup
                    .filter((page) => {
                      // return (
                      //   page.pageId !== selectedItem.pageId &&
                      //   page.organization !== undefined
                      // );
                      return true;
                    })
                    .map(
                      (page) =>
                        !Object.keys(selectedGroups).find(
                          (item) =>
                            selectedGroups[item]?.organization?.queryId ===
                            page.objectId.toString()
                        ) && (
                          <Row className="person-item" key={page.objectId}>
                            <Col span={5}>
                              <ReactSVG
                                src={`/images/community-blue-icon.svg`}
                                className="colorable mark-icon"
                              />
                            </Col>
                            <Col span={12}>
                              <h5>{page.info.name}</h5>
                            </Col>
                            <Col span={7} className="t-right">
                              <React.Fragment>
                                <Button
                                  className="beam-btn green-btn"
                                  onClick={() => {
                                    addAdminGroup(page);
                                  }}
                                >
                                  Add group
                                </Button>

                                <Dropdown
                                  trigger={["click"]}
                                  onVisibleChange={(visible) => {
                                    if (visible) {
                                      const queryId = page.objectId.toString();
                                      if (queryId) {
                                        dispatch(
                                          GET_ADMIN_GROUP_MEMBERS({
                                            queryId,
                                            callback: (response) => {
                                              console.log(
                                                "callback response here",
                                                response
                                              );
                                              const members = {};
                                              response?.data?.list.map(
                                                (user) => {
                                                  if(user.split(":")?.[1] === 'user'){
                                                    members[user.split(":")?.[2]] = {};
                                                  }
                                                  return user;
                                                }
                                              );
                                              console.log(
                                                "get page members",
                                                members
                                              );
                                              setGroupMembersList({
                                                ...groupMembersList,
                                                [page.objectId.toString()]:
                                                  members,
                                              });
                                            },
                                          })
                                        );
                                      }
                                    }
                                  }}
                                  overlay={groupMembers(
                                    groupMembersList?.[page.objectId.toString()]
                                  )}
                                  // overlay={menu}
                                  className="message-dropdown"
                                  placement="bottomRight"
                                >
                                  <a
                                    className="ant-dropdown-link"
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    <EllipsisOutlined />
                                  </a>
                                </Dropdown>
                              </React.Fragment>
                            </Col>
                          </Row>
                        )
                    )}
              </React.Fragment>
            </Col>
          </Row>

          <Row className="action-grp sticky-footer">
            <Col span={14} className="pr-2">
              <Form.Item>
                <Button
                  className="beam-btn green-btn cover w-full"
                  htmlType="submit"
                >
                  Save
                </Button>
              </Form.Item>
            </Col>
            <Col span={10} className="pl-2">
              <Button
                className="beam-btn orange-btn bordered w-full"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      {/* {groupModalOpen && (
        <AddGroupModal
          socket={socket}
          onClose={() => setgroupModalOpen(false)}
        />
      )}
      {inviteModalOpen && (
        <InvitePeopleModal
          socket={socket}
          onClose={() => setinviteModalOpen(false)}
        />
      )} */}
    </React.Fragment>
  );
};

export default CreateNewPageModal;
